import axiosInstance from '../utils/axios';

/**
 * 계정 잠금 관리 관련 API 서비스
 */
const accountLockoutService = {
  /**
   * 잠긴 계정 목록 조회
   * @returns {Promise<Array>} 잠긴 계정 목록
   */
  async getLockedAccounts() {
    const response = await axiosInstance.get('/admin/locked-accounts');
    
    if (response.data.success) {
      return response.data.data.accounts;
    }
    
    throw new Error(response.data.message || '계정 목록을 불러오는 중 오류가 발생했습니다.');
  },
  
  /**
   * 계정 잠금 해제
   * @param {number} userIdx 사용자 인덱스
   * @returns {Promise<boolean>} 성공 여부
   */
  async unlockAccount(userIdx) {
    const response = await axiosInstance.post('/admin/unlock-account', {
      user_idx: userIdx
    });
    
    if (response.data.success) {
      return true;
    }
    
    throw new Error(response.data.message || '계정 잠금 해제 중 오류가 발생했습니다.');
  },
  
  /**
   * 로그인 시도 횟수 설정 조회
   * @returns {Promise<Object>} 설정 값
   */
  async getLoginAttemptSettings() {
    const response = await axiosInstance.get('/settings/login-attempts');
    
    if (response.data.success) {
      return response.data.data;
    }
    
    throw new Error(response.data.message || '설정을 불러오는 중 오류가 발생했습니다.');
  },
  
  /**
   * 로그인 시도 횟수 설정 업데이트
   * @param {number} maxAttempts 최대 시도 횟수
   * @param {number} lockoutDuration 잠금 지속 시간(분)
   * @returns {Promise<Object>} 업데이트된 설정 값
   */
  async updateLoginAttemptSettings(maxAttempts, lockoutDuration) {
    const response = await axiosInstance.put('/settings/login-attempts', {
      max_attempts: maxAttempts,
      lockout_duration: lockoutDuration
    });

    console.log(response.data);
    
    if (response.data.success) {
      return response.data.data;
    }
    
    throw new Error(response.data.message || '설정을 업데이트하는 중 오류가 발생했습니다.');
  }
};

export default accountLockoutService;
